module.exports = __webpack_public_path__ + "img/117.23b3da40.jpg";